export interface PurchaseOrderHeaderExtraItem {
  id: string;
  purchaseOrderHeaderId: string;
  productId: string;
  productKey: string;
  productDescription: string;
  quantity: number;
  price: number;
  notes: string;
}
